module.exports = __webpack_public_path__ + "img/event-1.6b4b81ef.jpg";